import { Card, icons, useModal, sizing } from '@chillibean/component-library';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { AdminHeroBox } from '../../../../../HeroBox/AdminHeroBox/AdminHeroBox';
import { AdminList, FooterButtons } from '../../components/container';
import { StudyArmModal } from './components/container';

export function StudyArmsPage() {
  // HOOKS
  // Store
  const { data: protocol, loading } = useSelector((state) => state.protocolReducer.protocol);
  // Custom
  const {
    closeModal: closeStudyArmModal,
    data: selectedStudyArm,
    modalOpen: studyArmModalOpen,
    openModal: openStudyArmModal,
  } = useModal();

  const onClick = (id) => {
    if (protocol.locked) return;

    const studyArmToSelect = protocol.studyArms.find((studyArm) => studyArm.id === id);
    openStudyArmModal(studyArmToSelect);
  };

  return (
    <>
      <StudyArmModal
        onClose={closeStudyArmModal}
        onSuccess={closeStudyArmModal}
        studyArm={selectedStudyArm}
        visible={studyArmModalOpen}
      />
      <Container>
        <AdminHeroBox
          button={{
            disabled: protocol?.locked,
            loading: false,
            onClick: () => openStudyArmModal(),
            text: 'Create New',
          }}
          content="An Arm refers to a subgroup of patients that require a different visit schedule. Arms can be assigned to Visits in the Study Scheduler and Patients assigned to an Arm in the Site."
          disabled={protocol?.locked}
          header="Study Arm List"
          icon={icons.baselineFormatBulletList}
          loading={loading}
          subHeader="Study Arms"
        />
        {!loading && !protocol?.studyArms.length && <Card disabled>No study arms defined</Card>}
        {(loading || Boolean(protocol?.studyArms.length)) && (
          <AdminList
            elements={
              protocol
                ? protocol.studyArms.map((studyArm) =>
                    studyArm.listParams({ locked: protocol.locked, onClick: onClick }),
                  )
                : []
            }
            loading={loading}
          />
        )}
        <FooterButtons />
      </Container>
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizing.medium};
`;

export default StudyArmsPage;
